import axios from "axios";
import { testing } from "laravel-mix/src/Log";
import Vue from "vue";

window.Vue = Vue;

window.addEventListener("DOMContentLoaded", function () {
    new Vue({
        el: "#calculator",
        data: function () {
            return {
                result: null,
                surface: null,
                length: null,
                area: null,
                area_zone: null,
                height: null,
                prefix:"40",
                custom_prefix:null,
                errorMessage_surface: "",
                errorMessage_height: "",
                errorMessage_length: "",
                errorMessage_phone: "",
                errorMessage_checkbox_agreement:"",
                errorMessage_custom_prefix:"",
                checkbox_agreement:"",
                phone:null,
                loading:false,
                responseText:false,
                valid:true,
            };
        },
        mounted: function () {

            //todo - Refactoring pentru vue cu actiune @click.prevent
            // * Modal
            const requestBtn = document.querySelector(".q10__btn__request");
            const requestModal = document.querySelector("#requestModal");
            const requestForm = document.querySelector("#requestForm");
            const closeForm = document.querySelector("#closeForm");
            // * Open modal
           
            if (requestBtn) {
                requestBtn.addEventListener("click", (e) => {
                    e.preventDefault();
                    if (requestModal && requestForm) {
                        this.openModal(requestModal, requestForm);
                        // Focus
                        const phoneInput = document.getElementById("phone");
                        if (phoneInput) {
                            phoneInput.focus();
                        }
                    }
                });
            }
            // * Close modal
            if (requestModal && closeForm) {
                closeForm.addEventListener("click", () => {
                    this.closeModal(requestModal, requestForm);
                });
                requestModal.addEventListener("click", (e) => {
                    if (
                        e.target.attributes.id &&
                        e.target.attributes.id.nodeValue === "requestModal"
                    ) {
                        this.closeModal(requestModal, requestForm);
                    }
                });

                window.addEventListener("scroll", () => {
                    document.documentElement.style.setProperty(
                        "--scroll-y",
                        `${window.scrollY}px`
                    );
                });
            }
        },
        methods: {
            getValueArea(event) {
                let target = event.target;
                let options = target.options;
                let selectedIndex = options.selectedIndex;
                let selectedOption = options[selectedIndex] || null;
                this.area_zone = selectedOption
                    ? selectedOption.getAttribute("data-zone")
                    : null;
            },
            async checkValue() {
                 this.valid= true;
                if ( this.area_zone == null && this.area==null )
                {
                    this.valid = false;
                } 
                if (this.surface == null || this.surface == "") {
                    this.valid = false;
                }          
                else if ( this.surface != null && this.surface != "" && !(this.surface > 4 && this.surface < 36))
                {
                    this.valid = false;
                    this.errorMessage_surface = "5 - 35 m";

                } else {
                    this.errorMessage_surface = "";
                }
                if (this.height == null || this.height == "") {
                    this.valid = false;

                }
                else if (this.height != null && this.height != "" &&  !(this.height > 2 && this.height < 11)) {
                    this.valid = false;
                    this.errorMessage_height = "3 - 10 m";
                } else {
                    this.errorMessage_height = "";
                }

                if (this.length == null || this.length == "") {
                    this.valid = false;
                } 
                else if ( this.length != null &&  this.length != "" && !(this.length > 4 && this.length < 1001)) {
                    this.valid = false;
                    this.errorMessage_length = "5 - 1000 m";

                } else {
                    this.errorMessage_length = "";
                }
                
                if (this.valid) {
                    await axios
                        .get(
                            "/api/calculator?surface=" +
                                this.surface +
                                "&height=" +
                                this.height +
                                "&length=" +
                                this.length +
                                "&area=" +
                                this.area_zone
                        )
                        .then((response) => {
                            this.result = response.data ? response.data : null;
                        });
                        console.log( this.result);
                } else {
                    this.valid =false;
                    this.result = null;
                }
            },
            sendEmail(language){
                const vm = this;
                // var phoneNumber = 
                // vm.prefix=='others' && vm.custom_prefix!=null?
                // vm.custom_prefix+vm.phone: vm.prefix + vm.phone;
                var phoneNumber =  vm.formatRomaniaPhoneNumber(vm.phone);
                var checkValid = true;
                if (vm.phone == null || vm.phone == "" ) {
                    vm.errorMessage_phone = "can't be empty";
                    checkValid =false;
                } else if (vm.phone!=null && this.phone!='' && !vm.validatePhoneNumber(phoneNumber)) {
                    checkValid = false;
                    vm.errorMessage_phone = "not valid";
                } else {
                    vm.errorMessage_phone = "";
                }
                // if(vm.prefix=='others' && (vm.custom_prefix==null || vm.custom_prefix=="")){
                //     vm.errorMessage_custom_prefix = "can't be empty";
                // }
                // else {
                //     vm.errorMessage_custom_prefix = "";
                // }

                if (!vm.checkbox_agreement) {
                    vm.errorMessage_checkbox_agreement = "can't be empty";
                    checkValid =false;
                } else {
                    vm.errorMessage_checkbox_agreement = "";
                }
                if(vm.surface !=null &&vm.surface !='' 
                && vm.length !=null&& vm.length !='' 
                && vm.height !=null&& vm.height !='' 
                && vm.area_zone!=null && vm.area_zone!=''
                && vm.area!=null && vm.area!=''
                && checkValid)
                {
                    vm.loading = true;
                    vm.responseText = false;
                     axios
                    .get("/api/sendEmailAndMessage?surface=" +vm.surface+"&area=" +vm.area+'&height='+ vm.height+ '&length=' +vm.length+'&phone=' +phoneNumber+'&language='+language)
                    .then((response) => {
                        vm.responseText = true;
                    })
                    .catch((error)=>{
                        vm.responseText =false;
                    })
                    .then(()=>{
                        vm.loading=false;
                    });
                }   
                },
            chooseDropdownValue(event) {
                this.getValueArea(event);
                this.checkValue();
            },

            openModal(item1, item2) {
                item1.classList.add("active");
                item2.classList.add("active");
                const scrollY =
                    document.documentElement.style.getPropertyValue(
                        "--scroll-y"
                    );
                const body = document.body;
                body.style.position = "fixed";
                body.style.top = `-${scrollY}`;
                body.style.width = `100%`;
            },

            closeModal(item1, item2) {
                item1.classList.remove("active");
                item2.classList.remove("active");
                const body = document.body;
                const scrollY = body.style.top;
                body.style.position = "";
                body.style.top = "";
                body.style.width = ``;
                window.scrollTo(0, parseInt(scrollY || "0") * -1);
            },
             validatePhoneNumber(str) {
                var phoneNumber = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,8}$/im.test(str);
                return phoneNumber;
              }
,
              formatRomaniaPhoneNumber(str) {
                let phoneNumber = str.replace(/\D/g, '');
                if(phoneNumber.length==10 && phoneNumber[0]==0){
                    phoneNumber = "4"+phoneNumber;
                }
                if(phoneNumber.length==9 && phoneNumber[0]==7){
                    phoneNumber = "40"+phoneNumber;
                }
                return phoneNumber;
              }
              
        },
    });
});
